<template>
  <div class="mymap">
    <div class="search-box">
      <van-search
        v-model="search_key"
        placeholder="请输入搜索关键词"
        show-action
        @search="keySearch()"
        autocomplete="off"
        id="search"
      >
        <template #action>
          <div @click="keySearch()">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="con-box">
      <van-button
        type="primary"
        v-show="show"
        @click="getLocation"
        class="getLocation"
        >获取坐标</van-button
      >
      <div class="mapbox">
        <div class="map" id="container"></div>
        <div class="sign">
          <img
            src="../../../../static/img-location.png"
            alt=""
            class="centerIcon"
            width="30"
            height="30"
            v-show="show"
          />
        </div>
      </div>
    </div>
    <!-- 地址列表 -->
    <div class="list-box">
      <ul>
        <li
          class="listLi"
          v-for="(item, index) in lists"
          :key="index"
          @click="onResLi(item)"
        >
          <span>{{ item.name }}</span>
          <p>{{ item.address }}</p>
        </li>
      </ul>
    </div>
    <!-- 搜索列表 -->
    <div class="search-list" id="searchList" v-if="search_key">
      <ul>
        <li
          class="listLi"
          v-for="(item, index) in search_list"
          :key="index"
          @click="onSearchLi(item.location)"
        >
          <span>{{ item.name }}</span>
          <p>{{ item.address }}</p>
        </li>
        <li class="noResult" v-if="noSearchShow">
          暂无搜索结果（建议输入更详细的地址进行精确搜索）
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import AMap from 'AMap'
export default {
  data() {
    return {
      center: [119.237395, 26.052757], // 经度+纬度
      search_key: '', // 搜索值
      lists: [], // 地点列表
      search_list: [], // 搜索结果列表
      noSearchShow: false, // 无搜索结果提示，无搜索结果时会显示暂无搜索结果
      show: false
    }
  },
  created() {},
  mounted() {
    let map = new AMap.Map('container', {
      resizeEnable: true
    })
    let that = this
    AMap.plugin('AMap.Geolocation', function() {
      let geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000, // 超过10秒后停止定位，默认：5s
        buttonPosition: 'RB', // 定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true // 定位成功后是否自动调整地图视野到定位点
      })
      map.addControl(geolocation)
      geolocation.getCurrentPosition(function(status, result) {
        if (status === 'complete') {
          that.onComplete(result)
        } else {
          that.onError(result)
        }
      })
    })
  },
  watch: {
    search_key(newv, oldv) {
      if (newv === '') {
        this.search_list = []
        this.noSearchShow = false
      }
    }
  },
  methods: {
    onComplete(data) {
      console.log('定位结果：' + data.position)
      console.log('定位类别：' + data.location_type)
      if (data.accuracy) {
        console.log('精度：' + data.accuracy + ' 米')
      } // 如为IP精确定位结果则没有精度信息
      console.log('是否经过偏移：' + (data.isConverted ? '是' : '否'))
      // this.$dialog.alert({
      //   message: `定位结果：${data.position}`
      // })
      this.center = [data.position.lng, data.position.lat]
      this.adMap()

      // this.center = str.split(',')
    },
    onError(data) {
      console.log('定位失败', data.message)
      this.$dialog.alert({
        message: '定位失败'
      })
    },
    adMap() {
      // 初始化地图
      var map = new AMap.Map('container', {
        zoom: 16, // 缩放级别
        center: this.center // 设置地图中心点
        // resizeEnable: true,  //地图初始化加载定位到当前城市
      })
      this.show = true
      // 获取初始中心点并赋值
      var currentCenter = map.getCenter() // 此方法是获取当前地图的中心点
      this.center = [currentCenter.lng, currentCenter.lat] // 将获取到的中心点的纬度经度赋值给data的center
      // 根据地图中心点查附近地点，此方法在下方
      this.centerSearch()
      // 监听地图移动事件，并在移动结束后获取地图中心点并更新地点列表
      var moveendFun = e => {
        // 获取地图中心点
        currentCenter = map.getCenter()
        this.center = [currentCenter.lng, currentCenter.lat]
        // 根据地图中心点查附近地点
        this.centerSearch()
      }
      // 绑定事件移动地图事件
      map.on('moveend', moveendFun)
    },
    centerSearch() {
      AMap.service(['AMap.PlaceSearch'], () => {
        // 构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          type:
            '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施', // 兴趣点类别
          pageSize: 30, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: '全国', // 兴趣点城市
          autoFitView: false // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 根据地图中心点查附近地点
        placeSearch.searchNearBy(
          '',
          [this.center[0], this.center[1]],
          200,
          (status, result) => {
            if (status === 'complete') {
              this.lists = result.poiList.pois // 将查询到的地点赋值
            }
          }
        )
      })
    },
    keySearch() {
      AMap.service(['AMap.PlaceSearch'], () => {
        // 构造地点查询类
        var placeSearch = new AMap.PlaceSearch({
          type:
            '汽车服务|汽车销售|汽车维修|摩托车服务|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|商务住宅|政府机构及社会团体|科教文化服务|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施', // 兴趣点类别
          pageSize: 30, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: '全国', // 兴趣点城市
          citylimit: false, // 是否强制限制在设置的城市内搜索
          autoFitView: false // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(this.search_key, (status, result) => {
          if (status === 'complete') {
            if (result.poiList.count === 0) {
              this.search_list = []
              this.noSearchShow = true
            } else {
              this.search_list = result.poiList.pois // 将查询到的地点赋值
              this.noSearchShow = false
            }
          } else {
            this.search_list = []
            this.noSearchShow = true
          }
        })
      })
    },
    // 这里我们遍历search_list的时候将location传进来
    onSearchLi(location) {
      this.center = [location.lng, location.lat]
      this.adMap()
      this.search_key = ''
    },
    onResLi(e) {
      console.log(e)
      this.center = [e.location.lng, e.location.lat]
      this.adMap()
    },
    getLocation() {
      this.$dialog.alert({
        message: `经度：${this.center[0]}，纬度：${this.center[1]}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mymap {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .con-box {
    width: 100%;
    height: 40%;
    position: relative;
    .getLocation {
      position: absolute;
      top: 50%;
      right: 0;
      height: 40px;
      transform: translateY(-50%);
      z-index: 2222;
    }
    .mapbox,
    .map {
      width: 100%;
      height: 100%;
    }
  }
  .mapbox {
    position: relative;
  }
  .centerIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -30px;
    margin-left: -15px;
    z-index: 2222;
  }
  .list-box {
    height: calc(60% - 54px);
    overflow-y: scroll;
    background-color: #fff;
  }
  .search-list {
    position: fixed;
    top: 54px;
    width: 100%;
    z-index: 9999;
    overflow-y: scroll;
    height: calc(100% - 54px);
    background-color: #fff;
  }
  .listLi {
    padding: 15px;
    border-bottom: 1px solid #d7d7d7;
    p {
      font-size: 14px;
      color: #929292;
    }
  }
  .noResult {
    height: 100%;
    text-align: center;
  }
}
</style>
